// extracted by mini-css-extract-plugin
export default {"security-gate__container":"styles_security-gate__container__sat5s","security-gate__text":"styles_security-gate__text__Un9XU"};